import { render, staticRenderFns } from "./Crime.vue?vue&type=template&id=90bbb844&scoped=true&"
import script from "./Crime.vue?vue&type=script&lang=js&"
export * from "./Crime.vue?vue&type=script&lang=js&"
import style0 from "./Crime.vue?vue&type=style&index=0&id=90bbb844&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bbb844",
  null
  
)

export default component.exports